import ImageWithFallback from "components/common/ImageWithFallback";
import React from 'react';
import { openRecommendedEventModal } from "store/event/recommendedEventDetail.slice";
import { useAppDispatch } from "store/hooks";
import * as S from "./index.styles";

interface RecommendedEventCardProps {
  id: number;
  image_url?: string;
  activity_title: string;
  activity_description: string;
}

const RecommendedEventCard: React.FC<RecommendedEventCardProps> = ({
  id,
  image_url,
  activity_title,
  activity_description,
}) => {
  const dispatch = useAppDispatch();
  const MAX_DESCRIPTION_LENGTH = 115;

  const truncatedDescription = activity_description.length > MAX_DESCRIPTION_LENGTH
    ? activity_description.slice(0, MAX_DESCRIPTION_LENGTH) + '...'
    : activity_description;

  return (
    <S.RecommendedCard>
      <S.RecommendedCardImage
        as={ImageWithFallback}
        src={image_url}
        alt="Event"
      />
      <S.RecommendedCardTitle>{activity_title}</S.RecommendedCardTitle>
      <S.RecommendedCardDescription>
        {truncatedDescription}
      </S.RecommendedCardDescription>
      <S.RecommendedCardFooter>
        <S.RecommendedCardButton
          onClick={() => dispatch(openRecommendedEventModal(id))}
        >
          View event
        </S.RecommendedCardButton>

        {/*<S.RecommendedCardIcons>
          <FavoriteBorderIcon />
          <SendIcon />
        </S.RecommendedCardIcons>*/}
      </S.RecommendedCardFooter>
    </S.RecommendedCard>
  );
};

export default RecommendedEventCard; 